"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityFee = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const link_1 = __importDefault(require("@kyruus/link"));
const util_1 = require("../../common/util");
const styles_1 = require("./styles");
const FacilityFee = ({ ariaDescribedBy, intl, location, log }) => {
    if (location.email) {
        return (react_1.default.createElement(styles_1.FacilityFeeText, null,
            react_1.default.createElement(link_1.default, { "aria-describedby": ariaDescribedBy, title: intl.formatMessage(util_1.messages.regulatedSpacesBannerLinkTitle, { location_name: location.name }), href: location.email, onClick: () => {
                    log('user_action.direct_book.regulated_spaces_link_click');
                }, rel: "noopener noreferrer", target: "_blank" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, util_1.messages.regulatedSpacesBanner)))));
    }
    return (react_1.default.createElement(styles_1.FacilityFeeText, null,
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, util_1.messages.regulatedSpacesBanner))));
};
exports.FacilityFee = FacilityFee;
//# sourceMappingURL=LocationFacilityFee.js.map